// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3W0m7","approved":"Status_approved__1ScG2","rejected":"Status_rejected__1ME-D","expired":"Status_expired__3OkXn","label":"Status_label__s5tDs"};